export default __webpack_public_path__ + "static/media/primal_spirit_header.a0e1a247.jpg";